module.exports = __webpack_public_path__ + "static/media/hospital-user.f33e6a46.svg";